import { render } from "./ViaVerdePage.vue?vue&type=template&id=2d06a492&scoped=true"
import script from "./ViaVerdePage.vue?vue&type=script&lang=js"
export * from "./ViaVerdePage.vue?vue&type=script&lang=js"

import "./ViaVerdePage.vue?vue&type=style&index=0&id=2d06a492&scoped=true&lang=css"
import "./ViaVerdePage.vue?vue&type=style&index=1&id=2d06a492&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d06a492"]])

export default __exports__